<template>

  <v-row class="mb-5">

    <v-col cols="12" :xl="unhiddenActions.length ? 10 : 12">
      <v-row>
        <slot />
      </v-row>
    </v-col>

    <v-col v-if="unhiddenActions.length || headers.length > 0" cols="12" xl="2" class="text-right">

      <v-btn
        v-for="(action, index) in unhiddenActions"
        icon
        :href="action.href"
        :to="action.to"
        @click="action.click"
        :class="{'ml-4': index > 0}"
        :loading="action?.busy"
        :disabled="action?.disabled || action?.busy"
      >
        <v-icon :icon="action.icon" />
        <v-tooltip activator="parent" location="top" :text="action.title" />
      </v-btn>

      <column-picker class="ml-4" :headers="headers" v-model="enabledHeaders" :remember="rememberHeaders" />

    </v-col>

  </v-row>

</template>

<script setup lang="ts">

import { computed } from 'vue'
import ColumnPicker from './ColumnPicker.vue'
import type { ColumnPickerHeader, TableToolsAction } from '../types/misc'

const enabledHeaders = defineModel<string[]>('enabledHeaders')

interface Props {
  actions?: TableToolsAction[]
  headers?: ColumnPickerHeader[]
  rememberHeaders?: string
}

const props = withDefaults(defineProps<Props>(), {
  actions: () => [],
  headers: () => [],
})

const unhiddenActions = computed(() => props.actions.filter((action) => !action.hidden))

</script>
